import { combineReducers } from 'redux';

import inventoryManagement from './inventoryManagement/reducer';
import contentManagement from './contentManagement/reducer';

export default combineReducers({
  inventoryManagement,
  contentManagement,
});
